import { appUrls } from "@/constants";

/**
 * Deep link used when the free limit is reached: prefill image-video with the prompt and the
 * input/source asset (when the user supplied or chained one) so they can resume in the app.
 */
export function buildImageVideoRedirectUrl({
  prompt,
  assetId,
}: {
  prompt?: string | null;
  assetId?: string | null;
}): string {
  const url = new URL(appUrls.imageVideo);
  if (assetId) url.searchParams.set("asset_id", assetId);
  if (prompt) url.searchParams.set("prompt", prompt);
  return url.toString();
}
